import { useCallback } from 'react'
import { onboardingHelpPath } from '../components/HelpCenter/helpTree'
import { FEATURE_FLAGS } from './featureFlagKeys'
import { useFeatureFlag } from './useFeatureFlags'

// Help links on the onboarding pages. While the in-app help center is switched
// on they lead to the onboarding's own guide reader, which works without a
// login; switched off, they stay as written.
export function useOnboardingHelpLink(
  companyUid: string | undefined
): (url: string) => string {
  const inApp = useFeatureFlag(FEATURE_FLAGS.HELP_CENTER_IN_APP_ENABLED)
  return useCallback(
    (url: string) =>
      inApp && companyUid ? (onboardingHelpPath(companyUid, url) ?? url) : url,
    [inApp, companyUid]
  )
}
